<template>
  <div id="allMap" style="width: 100%;height: 300px"></div>
</template>
<script>
  // import BMap from 'BMap'
  export default {
    props:['cooperationSource'],
    name: "baidu-map",
    data(){
      return{
        cooperationValue:{
          area: '广州',
          address: '高晟广场2栋15层',
          detailAddress: '广州市天河区兴民路222号之三805室（部位：A）',
          tel: '',
          qq: ''
        }
      }
    },
    watch:{
      cooperationSource(value,oldValue){
        this.cooperationValue=value
        this.initBaiduMap()
      }
    },
    created(){
      //this.cooperationValue=this.cooperationSource
    },
    mounted() {
      this.initBaiduMap()
    },
    methods: {
      initBaiduMap() {
        console.log(this.cooperationValue)
          let bmap = new BMap.Map('allMap')
          bmap.enableScrollWheelZoom(true)
          let geoMap = new BMap.Geocoder()
          geoMap.getPoint(this.cooperationValue.address, function (point) {
            if (point) {
              bmap.centerAndZoom(point, 16);
              bmap.addOverlay(new BMap.Marker(point))
            } else {
              alert('您选择的地址没有解析结果')
            }
          },this.cooperationValue.area)
      }
    }
  }
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/baiduMap.vue